export enum ErrorCodes {
  ALREADY_SOLD = 'VEN1002',
  INEXISTENT = 'LDV2002',
  NOT_PERMITTED = 'VEN1004',
  RETRIEVE_PASSWORD = 'LCS1003',
  SERVICE_NOT_AVAILABLE = 'VEN1005',
  AUTHORIZATION_DENIED = 'AUTH001',
}
